import ReactModal from "react-modal";
import styled, { createGlobalStyle } from "styled-components";

export const ModalGlobalStyle = createGlobalStyle`
  ${({ ariaHiddenSelector }) =>
    `${ariaHiddenSelector} {
      isolation: isolate;
    }`}
`;

const defaultOverlayStyles = {
  backgroundColor: "rgba(0, 0, 0, 0.22)",
  boxSizing: "border-box",
  bottom: 0,
  display: "flex",
  flexDirection: "column",
  left: 0,
  position: "fixed",
  right: 0,
  top: 0
};

export const ModalBase = styled(ReactModal).attrs(props => ({
  style: {
    overlay: {
      ...defaultOverlayStyles,
      ...props?.style?.overlay
    }
  }
}))`
  -webkit-overflow-scrolling: touch;
  outline: none;
  overflow: auto;
`;
